import { Vue, Component } from "vue-property-decorator";
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';
import TrialButton from '@/components/trial-button/index.vue';
import user_module from '@/modules/user/index';
@Component({
  components: {
    TrialButton,
    RequestButton,
    RequestButtonFxd
  }
})

export default class PageLFS extends Vue {

  get token(){
    return user_module.token;
  }

}